export const MENU_HEIGHT = 72;
export const MOBILE_MENU_HEIGHT = 44;
export const TOP_BANNER_HEIGHT = 70;
export const TOP_BANNER_HEIGHT_MOBILE = 84;

export const INFO_CHAIN: any = {
  onus: {
    usdt: "0xff276c6bca1F66Fd54a8915e830735D6ab0C7B09",
    vndc: "0xa6b9579563A48a0540BB53853Ae0947972371169",
    url: "https://miaswap.io/",
    chain: "onus",
  },
  bsc: {
    usdt: "0x55d398326f99059fF775485246999027B3197955",
    vndc: "0xA276DC434A366C62ef010585b3885D0C85154389",
    url: "https://pancakeswap.finance/swap",
    chain: "bnb",
  },
  bnb: {
    usdt: "0x55d398326f99059fF775485246999027B3197955",
    vndc: "0xA276DC434A366C62ef010585b3885D0C85154389",
    url: "https://pancakeswap.finance/swap",
    chain: "bnb",
  },
  polygon: {
    usdt: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    vndc: "0xd0076D7E57AAC42ec3F9d6E7C604d04A5b7030Fa",
    url: "https://app.uniswap.org/explore/tokens",
    chain: "polygon",
  },
};
